interface Props {
  color?: string
  width?: number
  height?: number
}

export const AlignLeftIcon = ({ color = '#6F6F6F', width = 19, height = 16 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.5 15C14.7761 15 15 15.2239 15 15.5C15 15.7761 14.7761 16 14.5 16H0.5C0.223858 16 0 15.7761 0 15.5C0 15.2239 0.223858 15 0.5 15H14.5ZM18.5 10C18.7761 10 19 10.2239 19 10.5C19 10.7761 18.7761 11 18.5 11H0.5C0.223858 11 0 10.7761 0 10.5C0 10.2239 0.223858 10 0.5 10H18.5ZM14.5 5C14.7761 5 15 5.22386 15 5.5C15 5.77614 14.7761 6 14.5 6H0.5C0.223858 6 0 5.77614 0 5.5C0 5.22386 0.223858 5 0.5 5H14.5ZM18.5 0C18.7761 0 19 0.223858 19 0.5C19 0.776142 18.7761 1 18.5 1H0.5C0.223858 1 0 0.776142 0 0.5C0 0.223858 0.223858 0 0.5 0H18.5Z"
        fill={color}
      />
    </svg>
  )
}
